import { gql } from '@apollo/client';

export const ServiceRequestsDocument = gql`
    query serviceRequestsV2($orderBy: OrderBy, $orderDir: Sort, $filterBy: ServiceRequestFilterInput) {
        serviceRequestsV2(orderBy: $orderBy, orderDir: $orderDir, filterBy: $filterBy) {
            id
            files {
                url
                id
                mimeType
                name
                fileName
                isImage
                size
            }
            rentalObject {
                rentalType
                id
                country
                city
                street
                houseNumber
                apartmentNumber
                roomNumber
            }

            title
            description
            submitDate
            status
            type
            serviceRequestType {
                id
                isDefault
                isActive
                internalTitle
                titles {
                    text
                    langCode
                }
            }
            messagingChannelKey
        }
    }
`;
